<template>
	<v-dialog
		v-model="show"
		max-width="500"
		persistent
	>
		<v-card>
			<v-card-title
				:class="color"
				class="body-2 white--text"
			>
				<slot name="title">{{ title }}</slot>
			</v-card-title>
			<slot name="text" />
			<v-card-text v-if="text" v-html="text" />
			<v-divider />
			<v-card-actions>
				<v-spacer />
				<slot name="buttons" :callback="returnValue">
					<v-btn
						:color="color"
						flat
						@click="returnValue(true)"
					>
						OK
					</v-btn>
				</slot>
				<v-btn
					flat
					@click="returnValue(false)"
				>
					Cancel
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	data() {
		return {
			show: false,
			title: 'Confirm',
			color: 'primary',
			text: null,
			resolve: null,
			reject: null,
		};
	},
	methods: {
		returnValue(val) {
			this.resolve(val);
			this.show = false;
		},
		createConfirm(title = this.title, color = this.color, text = this.text) {
			this.title = title;
			this.color = color;
			this.text = text;
			this.show = true;
			return new Promise((resolve, reject) => {
				this.resolve = resolve;
				this.reject = reject;
			});
		},
	},
};
</script>
